import React, { useState } from "react";

// Material-UI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@material-ui/core";

// Components
import {
  FieldValue,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";
import {
  penukaranRewardCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useSnackbar } from "notistack";

// Router

function DialogSuccess({
  open,
  data,
  handleClose,
  handleCloseAlamat,
  handleCloseDrawer,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [catatan, setCatatan] = useState("");
  // console.log(catatan,data);
  const { profil } = useData();
  const [loading, setLoading] = useState(false);

  // console.log(data);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // const hasil = { ...data, catatan: catatan };
      const hasil = {
        user_id: profil.id,
        alamat_pengiriman: data?.alamat_pengiriman,
        product_reward: {
          nama: data?.product_reward?.nama,
          variantIdSelected: data?.product_reward?.variants?.[0],
        },
        total_penukaran_reward: data?.product_reward?.variants?.[0]?.harga_poin,
        status: "pending",
        catatan: catatan,
        created_at: FieldValue.serverTimestamp(),
        updated_at: FieldValue.serverTimestamp(),
      };

      const dataRE = {
        user_id: profil.id,
        product_reward: {
          product_reward_id: data?.product_reward?.id,
          variant_id: data?.product_reward?.variants?.[0]?.id,
          jumlah: 1,
        },
        poin: data?.product_reward?.variants?.[0]?.harga_poin,
      };

      // console.log(hasil, dataRE);

      const rewardExchange = firefunctions.httpsCallable("rewardExchange");

      await rewardExchange(dataRE);

      await penukaranRewardCollection.add(hasil);
      enqueueSnackbar("Produk Reward Berhasil Diorder", {
        variant: "success",
      });
      handleCloseDrawer();
      handleClose();
      handleCloseAlamat();
      // history.push("/akun/rewardlist");
    } catch (e) {
      handleCloseDrawer();
      handleClose();
      handleCloseAlamat();
      enqueueSnackbar(e.message, {
        variant: "error",
      });
      console.log(e.message);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setCatatan(e.target.value);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
      // style={{
      //   textAlign: "center",
      // }}
    >
      <DialogTitle>Detail Pengiriman</DialogTitle>
      <DialogContent dividers style={{padding:10}}>
        <div
          style={{
            marginTop: "5px",
            // marginBottom: "20px",
            // marginLeft: 24,
            border: "1px solid ",
            // marginRight: 24,
            borderRadius: 4,
            padding: "12px",
          }}
        >
          <div>
            <Typography style={{ fontSize: 15 }}>Alamat</Typography>
          </div>
          <div style={{ display: "inline-grid" }}>
            <Typography style={{ fontSize: 13 }}>
              {data?.alamat_pengiriman?.nama_penerima} (
              {data?.alamat_pengiriman?.no_telepon})
            </Typography>
            <Typography style={{ fontSize: 13 }}>
              {data?.alamat_pengiriman?.kelurahan?.name},{" "}
              {data?.alamat_pengiriman?.kecamatan?.name},{" "}
              {data?.alamat_pengiriman?.kota?.name},{" "}
              {data?.alamat_pengiriman?.provinsi?.name},{" "}
              {data?.alamat_pengiriman?.kelurahan?.postcode}
            </Typography>
          </div>
        </div>
        {/* <Typography
          style={{ width: "90%", marginLeft: "5%", marginBottom: "1%" }}
        >
          Catatan
        </Typography> */}
        {/* <Divider /> */}
        {/* <Typography style={{ fontSize: 15, marginTop:"20px" }}>Catatan</Typography> */}
        <TextField
          name="catatan"
          label="Isi Catatan"
          fullWidth
          style={{ marginTop: "15px", marginBottom: "5px" }}
          // placeholder="Optional"
          variant="outlined"
          onChange={handleChange}
          // InputLabelProps={{
          //   shrink: true,
          // }}
          value={catatan}
          disabled={loading}
          // type="number"
          // autoComplete="off"
        />
      </DialogContent>
      <DialogActions>
        {/* <div
          // style={{
          //   display: "flex",
          //   // flexDirection: "column",
          //   // flex: 1,
          // }}
        > */}
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={handleClose}
          style={{
            textTransform: "capitalize",
          }}
          disabled={loading}
        >
          Batalkan
        </Button>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit}
          style={{
            textTransform: "capitalize",
          }}
          disabled={loading}
        >
          Lanjutkan
        </Button>
        {/* <Gap height={8} /> */}
        {/* </div> */}
      </DialogActions>
    </Dialog>
  );
}

export default DialogSuccess;
